
import { SystemMessageEntityDecoratorBase } from './system-message.decorator.base';


export class SystemMessageEntityDecorator extends SystemMessageEntityDecoratorBase {
  constructor() {
    super();
  }
}



